"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RestorClient = void 0;
exports.createRestorClient = createRestorClient;
const http_client_1 = require("./http-client");
const auth_1 = require("./resources/auth");
const catalog_1 = require("./resources/catalog");
const delivery_1 = require("./resources/delivery");
const misc_1 = require("./resources/misc");
const organization_1 = require("./resources/organization");
const orders_1 = require("./resources/orders");
const inventory_1 = require("./resources/inventory");
const platform_1 = require("./resources/platform");
const pos_1 = require("./resources/pos");
const storefront_1 = require("./resources/storefront");
/**
 * The full RESTOR API surface, grouped by resource.
 *
 * Every app builds one of these at startup and shares it. Apps only touch the
 * groups they need — the POS never imports the platform resource — but they all
 * get the same auth, refresh and error behaviour (TZ §45).
 */
class RestorClient {
    http;
    auth;
    platform;
    company;
    branches;
    employees;
    roles;
    catalog;
    orders;
    payments;
    kitchen;
    cash;
    pos;
    couriers;
    courierApp;
    customers;
    marketing;
    telegram;
    tables;
    audit;
    reports;
    inventory;
    storefront;
    /** The signed-in storefront customer (Mini App). */
    me;
    constructor(options) {
        this.http = new http_client_1.HttpClient(options);
        this.auth = new auth_1.AuthResource(this.http);
        this.platform = new platform_1.PlatformResource(this.http);
        this.company = new organization_1.CompanyResource(this.http);
        this.branches = new organization_1.BranchesResource(this.http);
        this.employees = new organization_1.EmployeesResource(this.http);
        this.roles = new organization_1.RolesResource(this.http);
        this.catalog = new catalog_1.CatalogResource(this.http);
        this.orders = new orders_1.OrdersResource(this.http);
        this.payments = new orders_1.PaymentsResource(this.http);
        this.kitchen = new orders_1.KitchenResource(this.http);
        this.cash = new pos_1.CashResource(this.http);
        this.pos = new pos_1.PosResource(this.http);
        this.couriers = new delivery_1.CouriersResource(this.http);
        this.courierApp = new delivery_1.CourierAppResource(this.http);
        this.customers = new misc_1.CustomersResource(this.http);
        this.marketing = new misc_1.MarketingResource(this.http);
        this.telegram = new misc_1.TelegramResource(this.http);
        this.tables = new misc_1.TablesResource(this.http);
        this.audit = new misc_1.AuditResource(this.http);
        this.reports = new orders_1.ReportsResource(this.http);
        this.inventory = new inventory_1.InventoryResource(this.http);
        this.storefront = new storefront_1.StorefrontResource(this.http);
        this.me = new storefront_1.MeResource(this.http);
    }
}
exports.RestorClient = RestorClient;
function createRestorClient(options) {
    return new RestorClient(options);
}
//# sourceMappingURL=client.js.map